import classNames from 'classnames'
import './index.scss'
import React, {useEffect, useRef, useState} from 'react'

const getFirstOverflowedParent = element => {
    let parent = element.offsetParent
    while (parent) {
        const parentStyle = window.getComputedStyle(parent)
        if (parentStyle.overflow !== 'visible') {
            return parent
        }
        parent = parent.offsetParent
    }
    return window.document.body
}

const InputInfo = ({text, overrideClass}) => {
    const [isOverlapped, setIsOverlapped] = useState(false)
    const infoBoxRef = useRef(null)
    useEffect(() => {
        const rect = infoBoxRef.current.getBoundingClientRect()
        const parentRect = getFirstOverflowedParent(infoBoxRef.current).getBoundingClientRect()
        if (rect.left + rect.width > (parentRect.left + parentRect.width)) {
            setIsOverlapped(true)
        }
    }, [])
    return (
        <div
            ref={infoBoxRef}
            className={classNames('info-box', overrideClass, {
                'info-box-left': isOverlapped
            })}
        >
            <p dangerouslySetInnerHTML={{__html: text}} />
        </div>
    )
}

export default InputInfo
